import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "@/locales/ar.json";
import en from "@/locales/en.json";
import tr from "@/locales/tr.json";

const STORAGE_KEY = "istanbul-real-estate-language";

const stored = (typeof window !== "undefined"
  ? window.localStorage.getItem(STORAGE_KEY)
  : null) as "ar" | "en" | "tr" | null;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
      tr: { translation: tr },
    },
    lng: stored && ["ar", "en", "tr"].includes(stored) ? stored : "ar",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export const applyHtmlDir = (lang: "ar" | "en" | "tr") => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
};

applyHtmlDir((i18n.language as "ar" | "en" | "tr") ?? "ar");

export default i18n;
